import React from "react"

function StatisticA() {
  return (
    <svg viewBox="0 0 266 150" fill="none">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={45}
        y={66}
        width={26}
        height={10}
        rx={5}
        fill="var(--solid-900)"
      />
      <rect x={43} y={80} width={30} height={4} rx={2} fill="var(--base-500)" />
      <rect
        x={95}
        y={66}
        width={26}
        height={10}
        rx={5}
        fill="var(--solid-900)"
      />
      <rect x={93} y={80} width={30} height={4} rx={2} fill="var(--base-500)" />
      <rect
        x={145}
        y={66}
        width={26}
        height={10}
        rx={5}
        fill="var(--solid-900)"
      />
      <rect
        x={143}
        y={80}
        width={30}
        height={4}
        rx={2}
        fill="var(--base-500)"
      />
      <rect
        x={195}
        y={66}
        width={26}
        height={10}
        rx={5}
        fill="var(--solid-900)"
      />
      <rect
        x={193}
        y={80}
        width={30}
        height={4}
        rx={2}
        fill="var(--base-500)"
      />
    </svg>
  )
}

export default StatisticA;
